<template lang="html">
  <div :class="[klass]">
    <div :class="['input-container']">
      <input
        :type="currentType"
        :name="name"
        :class="[
          'form-input',
          inputSize,
          error ? 'error-input' : '',
          type === 'password' ? 'input-password' : '',
          locked || iconClass ? 'input-locked' : '',
        ]"
        :placeholder="placeholder"
        :value="value"
        @input="event => $emit('update:value', event.target.value)"
        :disabled="locked || disabled"
      />
      <div
        class="show-hide"
        @click="changeShowHide"
        v-if="type === 'password' && !locked"
      >
        {{ showHide }}
      </div>
      <div
        :class="['input-action-icon', iconClass ? [iconClass, 'cursor-pointer'] : 'si-lock_simple']"
        @click="onIconClick" 
        v-if="locked || iconClass"
      >
      </div>
    </div>
    <div class="error-text" v-if="displayError && error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    klass: {
      type: String,
      default: "",
    },
    inputSize: {
      type: String,
      default: "input-default-size",
    },
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "",
    },
    locked: {
      type: Boolean,
      default: false,
    },
    displayError: {
      type: Boolean,
      default: true,
    },
    iconClass: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onIconClick: {
      type: Function,
      default: () => {},
    }
  },
  data() {
    return {
      showHide: "Show",
      currentType: this.type,
    };
  },
  methods: {
    changeShowHide() {
      if (this.showHide === "Show") {
        this.showHide = "Hide";
        this.currentType = "text";
      } else {
        this.showHide = "Show";
        this.currentType = "password";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  position: relative;
  display: flex;
  justify-content: center;

  input {
    margin-top: 0 !important;
  }

  .form-input {
    height: 48px;
    padding: 12px 16px;

    color: #6d6d6d;
    background: white;
    font-size: 16px;

    border: 1px solid #dddddd !important;
    box-sizing: border-box;
    border-radius: 4px;

    &:focus {
      border: 1px solid #d833b4 !important;
    }
  }

  .input-password {
    padding-right: 64px;
  }

  .input-locked {
    padding-right: 52px;
  }

  .input-default-size {
    width: calc(min(314px, 90vw)) !important;
  }

  .input-full-width {
    width: 100% !important;
  }

  .error-input {
    border: 1px solid #d00000 !important;
    color: #d00000;

    &:focus {
      border: 1px solid #d00000 !important;
    }
  }

  ::placeholder {
    font-size: 16px;
    color: #8e8e8e;
    opacity: 1;
  }

  input::-ms-reveal {
    display: none;
  }

  .show-hide {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 24px;
    cursor: pointer;

    color: #a95597;
    font-size: 14px;
  }

  .input-action-icon {
    position: absolute;
    top: 18px;
    right: 22px;

    color: #929292;
    font-size: 14px;
    font-weight: 500;
  }
}

input:disabled {
  background: #ffffff;
}

.error-text {
  text-align: left;
  font-size: 13px !important;
}
</style>
